module.exports = __webpack_public_path__ + "img/oconnor_large.71de9c40.png";